// extracted by mini-css-extract-plugin
export var readonly = "_i5-1";
export var star = "_i5-0";